// UK local (Europe/London) date/time helpers for the article Scheduled
// Publishing feature — no timezone library needed, Intl already knows the
// GMT/BST rules. londonLocalToUtcIso treats the given date/time as UK wall
// clock and returns the correct UTC instant regardless of the admin's own
// browser timezone.
const LONDON_TZ = "Europe/London";

function londonPartsOf(date) {
  return new Intl.DateTimeFormat("en-US", {
    timeZone: LONDON_TZ,
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  }).formatToParts(date).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
}

export function londonLocalToUtcIso(dateStr, timeStr) {
  if (!dateStr || !timeStr) return null;
  const [y, m, d] = dateStr.split("-").map(Number);
  const [hh, mm] = timeStr.split(":").map(Number);
  const asUtc = new Date(Date.UTC(y, m - 1, d, hh, mm, 0));
  const p = londonPartsOf(asUtc);
  const hour24 = p.hour === "24" ? 0 : Number(p.hour);
  const shownAsLondon = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), hour24, Number(p.minute), Number(p.second));
  const offsetMs = shownAsLondon - asUtc.getTime();
  return new Date(asUtc.getTime() - offsetMs).toISOString();
}

export function utcIsoToLondonParts(iso) {
  if (!iso) return { date: "", time: "" };
  const p = londonPartsOf(new Date(iso));
  const hour24 = p.hour === "24" ? "00" : p.hour;
  return { date: `${p.year}-${p.month}-${p.day}`, time: `${hour24}:${p.minute}` };
}

export function formatUkDateTime(iso) {
  if (!iso) return "";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: LONDON_TZ,
    day: "numeric", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false, timeZoneName: "short",
  }).format(new Date(iso));
}
